import { CanDeactivateFn } from '@angular/router';

export interface SyncsRoleStatusOnLeave {
  syncRoleStatusOnLeave(): void;
}

export const roleStatusSyncGuard: CanDeactivateFn<SyncsRoleStatusOnLeave> = (component) => {
  component.syncRoleStatusOnLeave();
  return true;
};
